import { fetchJson } from "../lib/api";
import { isDemoMode } from "../lib/env";

export function documentPdfUrl(
  docId: string,
  pageNo?: number | null,
  token?: string | null,
) {
  // Demo-Mode: kein Backend — statische, wasserzeichenbehaftete Demo-PDFs
  // unter /demo/documents/ (erzeugt von scripts/build_demo_documents.py).
  if (isDemoMode()) {
    const fragment = pageNo ? `#page=${pageNo}` : "";
    return `/demo/documents/${demoDocumentPathSegment(docId)}.pdf${fragment}`;
  }
  const base = `/api/documents/${encodeURIComponent(docId)}/pdf`;
  const query = token ? `?token=${encodeURIComponent(token)}` : "";
  const fragment = pageNo ? `#page=${pageNo}` : "";
  return `${base}${query}${fragment}`;
}

export function documentLinePreviewUrl(
  docId: string,
  linePos: string | number,
  scale = 2,
  token?: string | null,
) {
  if (isDemoMode()) {
    return `/demo/documents/${demoDocumentPathSegment(docId)}/line-${encodeURIComponent(String(linePos))}.png`;
  }
  const params = new URLSearchParams({ scale: String(scale) });
  if (token) {
    params.set("token", token);
  }
  return `/api/documents/${encodeURIComponent(docId)}/lines/${encodeURIComponent(String(linePos))}/preview.png?${params.toString()}`;
}

function demoDocumentPathSegment(docId: string): string {
  // The generated static filenames keep the document-type separator (`:`).
  // Vite's static fallback does not resolve the percent-encoded separator and
  // would otherwise return the app HTML for a PDF or line preview request.
  return encodeURIComponent(docId).replaceAll("%3A", ":");
}

export type DocumentMediaToken = {
  token: string;
  expires_at: number;
};

// Short-lived token that authorizes PDF/preview URLs opened by plain browser
// navigation (those requests cannot attach the Supabase Bearer header).
export function fetchDocumentMediaToken(): Promise<DocumentMediaToken> {
  return fetchJson<DocumentMediaToken>("/api/documents/media-token");
}
